import axios from 'axios';
import urls from '../constants/urls';
import { isPullRequestApp } from '../utils/config';
import { retrieveApiDetails } from '../utils/api';

export const SWITCH_API_CLIENT = 'switchApi';
export const NEWS_FEED_API_CLIENT = 'newsFeedApi';
export const ORGANISATIONS_API_CLIENT = 'organisationsApi';

export const getClientName = action => action.payload.customClient;

export const isAxiosRequest = action =>
  action.payload && action.payload.request;

export const multiClientHandler = ({ dispatch, getState }) => {
  return next => action => {
    let currentApiDetails = retrieveApiDetails();

    if (!isAxiosRequest(action) || !currentApiDetails) {
      return next(action);
    }

    const clientName = getClientName(action);

    const { url } = currentApiDetails.attributes;
    const authUrl = currentApiDetails.attributes['auth-url'];
    
    let baseURL;
    if (clientName === SWITCH_API_CLIENT) {
      if (isPullRequestApp) {
        baseURL = `${urls.switchAppUrl}/api`;
      } else {
        baseURL = urls.baseSwitchUrl(authUrl);
      }
    } else if (clientName === NEWS_FEED_API_CLIENT) {
      if (isPullRequestApp) {
        baseURL = `${urls.newsFeedUrl}/api`;
      } else {
        baseURL = urls.baseNewsFeedUrl(authUrl);
      }
    } else if (clientName === ORGANISATIONS_API_CLIENT) {
      if (isPullRequestApp) {
        baseURL = `${urls.organisationsUrl}/organisations-api`;
      } else {
        baseURL = urls.baseOrganisationsUrl(authUrl);
      }
    } else {
      baseURL = urls.baseInductionUrl(url);
    }
    
    // Set the baseURL on axios defaults
    axios.defaults.baseURL = baseURL;

    return next(action);
  };
};
